import { Injectable } from '@angular/core';
import { IndexdbCachingService, InMemoryCachingService } from '../../../services.module';

@Injectable({
  providedIn: 'root'
})
export class UnsyncCachingService {

  constructor(
    private storageService: IndexdbCachingService,
    private inMemoryCachingService: InMemoryCachingService,
  ) { }

  init() { }

  async getLastActiveTabUrl(): Promise<string> {
    let lastActiveTabUrl = this.inMemoryCachingService.getLastActiveTabUrl();
    if (!lastActiveTabUrl) {
      // lastActiveTabUrl = await this.storageService.getLastActiveTabUrl();
      this.inMemoryCachingService.setLastActiveTabUrl(lastActiveTabUrl);
    }
    return lastActiveTabUrl;
  }
  setLastActiveTabUrl(url: string): Promise<void> {
    this.inMemoryCachingService.setLastActiveTabUrl(url);
    // return this.storageService.setLastActiveTabUrl(url);
    return new Promise((resolve) => {
      resolve();
    })
  }
}
